<template>
    <v-row class="no-frame">
        <v-col class="no-frame pr-2">
            <div class="v-flex w-100">
                <f-read-only-field
                    v-if   = "!edit.verficationDate"
                    class  = "readonly-date mb-0"
                    :label = "$t('invoice.verificationDate')"
                    :value = "this.data.verficationDate ? format (this.data.verficationDate) : 'noch nicht geprüft'"
                    :collective = "collective"
                    :filled     = "!collective"
                    dense
                >
                    <template v-slot:prepend>
                        <c-toolbar-button
                            size     = "18"
                            color    = "primary"
                            :icon    = "edit.verficationDate ? 'mdi-eye' : 'mdi-pen'"
                            :tooltip = "edit.verficationDate ? $t('invoice.dates.verification.view') : $t('invoice.dates.verification.edit')"
                            @click   = "onVerficationDate"
                        />
                    </template>
                </f-read-only-field>

                <f-date-picker
                    class   = "mt-0"
                    v-if    = "edit.verficationDate"
                    v-model = "data.verficationDate"
                    label   = "invoice.verificationDate"
                    :time   = "false"
                    background-color = "white"
                    hide-details
                />
            </div>
        </v-col>
        <v-col class="no-frame pl-2">
            <div class="v-flex w-100">
                <f-read-only-field
                    v-if   = "!edit.sendDate"
                    class  = "readonly-date"
                    :label = "$t('invoice.sendDate')"
                    :value = "this.data.sendDate ? format (this.data.sendDate) : 'noch nicht gesendet'"
                    :collective = "collective"
                    :filled     = "!collective"
                    dense
                >
                    <template v-slot:prepend>
                        <c-toolbar-button
                            size     = "18"
                            color    = "primary"
                            :icon    = "edit.sendDate ? 'mdi-eye' : 'mdi-pen'"
                            :tooltip = "edit.sendDate ? $t('invoice.dates.send.view') : $t('invoice.dates.send.edit')"
                            @click   = "onSendDateEdit"
                        />
                    </template>
                </f-read-only-field>

                <f-date-picker
                    class   = "mt-0"
                    v-if    = "edit.sendDate"
                    v-model = "data.sendDate"
                    label   = "invoice.sendDate"
                    :time   = "false"
                    background-color = "white"
                    hide-details
                />
            </div>
        </v-col>
    </v-row>
</template>

<script>

import Core           from "@/modules/core/service/Core";
import FDatePicker    from "@/modules/core/components/utils/FDatePicker.vue";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";

export default {
    name: "PIncInvoiceDates",

    components: {
        CToolbarButton,
        FReadOnlyField,
        FDatePicker
    },

    props: {
        data: {
            required: true,
            type: Object,
        },

        collective: {

        }
    },


    data: () => ({
        edit: {
            verficationDate: false,
            sendDate: false
        },
    }),


    methods: {
        format (value) {
            return Core.format.date.display(value);
        },

        onVerficationDate () {
            this.edit.verficationDate = !this.edit.verficationDate;
        },

        onSendDateEdit () {
            this.edit.sendDate = !this.edit.sendDate;
        },
    }
}
</script>

<style scoped>

.readonly-date {
    width: 100%;
}

</style>